<div class="container my-3 p-4">
	<div class="row mb-2">
		<div class="col-12">
			<h1 *ngIf="!isPreterm" class="page-title">{{'RENEWAL_INPROGRESS_STATIC_TEXT1' | globalTranslate }}</h1>
			<h1 *ngIf="isPreterm" class="page-title">{{'QFR_INPROGRESS_STATIC_TEXT1' | globalTranslate }}</h1>
		</div>
	</div>
     <nh-alert type="danger" [isOpen]="optionNotSelected">
        <div class="row">
          <div class="col-auto icon">
            <img src="../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg" alt="" />
          </div>
          <div class="col message">
            <span>{{ 'SELECT_TILE' | globalTranslate}}</span>
          </div>
        </div>
      </nh-alert>
	<div *ngIf="!mobileUser" class="ps-1 pb-1 hover-red">
		<div tabindex="0" class="btn btn-link hover-red" (click)="onPreviousClick()">
			<svg xmlns="http://www.w3.org/2000/svg" width="16.875" height="15.75" viewBox="0 0 16.875 15.75">
				<g id="_icons_arrow-back-outline" data-name="⚛️ icons/arrow-back-outline" transform="translate(0)">
					<path id="Combined_Shape" data-name="Combined Shape"
						d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
						transform="translate(0)" fill="#174a7c" />
				</g>
			</svg>
			<span class="ps-2">{{'BACK_TO_PREVIOUS_PAGE' | globalTranslate}}</span>
		</div>
	</div>
	<br />
	<div class="bg-white p-4">
		<h2 *ngIf="!isPreterm" class="section-header">{{'RENEWAL_INPROGRESS_STATIC_TEXT2' | globalTranslate }}</h2><hr *ngIf="!isPreterm">
		<h2 *ngIf="isPreterm" class="section-header">{{'QFR_INPROGRESS_STATIC_TEXT1' | globalTranslate }}</h2><hr *ngIf="isPreterm">
		<p *ngIf="!isPreterm" class="static-text">{{'RENEWAL_INPROGRESS_STATIC_TEXT3' | globalTranslate }}
		<p *ngIf="isPreterm" class="static-text">{{'QFR_INPROGRESS_STATIC_TEXT3' | globalTranslate }}
		</p>
		<p *ngIf="!isPreterm" class="static-text">
			{{'RENEWAL_INPROGRESS_STATIC_TEXT4' | globalTranslate }}
		</p>
		<p *ngIf="isPreterm" class="static-text">
			{{'QFR_INPROGRESS_STATIC_TEXT4' | globalTranslate }}
		</p>
		<p class="static-text">{{'RENEWAL_INPROGRESS_STATIC_TEXT5' | globalTranslate }}
		</p>
		<div>
			<div>
				<div *ngIf="!isOverSevenDays">
					<div tabindex="0" class="card card-body shadow mb-2 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start"
						[ngClass]="{'applyColor': appType === 'continue'}" (click)="select('continue')" role="button">
			
					<div class="mb-3 mb-md-0 me-0  flex-shrink-0 d-flex justify-content-center">
						<img class="dot" aria-hidden="true" alt="" src="../../../assets/images/Icons/Take_back.svg">
					</div>
						<div class="flex-grow-1 min-w-0 w-100">
							<div class="section-column">
							<strong *ngIf="!isPreterm" class="tile_header">{{'RENEWAL_INPROGRESS_STATIC_TEXT6' | globalTranslate }}<span class="sr-only">.</span></strong>
							<strong *ngIf="isPreterm" class="tile_header">{{'QFR_INPROGRESS_STATIC_TEXT6' | globalTranslate }}<span class="sr-only">.</span></strong>
								<ul *ngIf="caseDetails" class="list-unstyled">
								<li class="small tile-margin tile-text">{{'TABLE_DETAIL_NUMBER' | globalTranslate }}: {{caseDetails.caseNumber}}<span class="sr-only">.</span></li>
								<li class="small tile-text">{{'RENEWAL_INPROGRESS_STATIC_TEXT7' | globalTranslate }}: {{caseDetails.headOfHousehold}}<span class="sr-only">.</span></li>
								<li class="small tile-text">{{'RENEWAL_INPROGRESS_STATIC_TEXT8' | globalTranslate }} {{caseDetails.startedBy}}<span class="sr-only">.</span></li>
								<li class="small tile-text">{{'RENEWAL_INPROGRESS_STATIC_TEXT9' | globalTranslate }} {{caseDetails.startedOn | date:'MM/dd/yyyy'}}<span class="sr-only">.</span></li>
								<li class="small tile-text">{{'RENEWAL_INPROGRESS_STATIC_TEXT10' | globalTranslate }} {{caseDetails.lastAccessedBy}}<span class="sr-only">.</span></li>
								<li class="small tile-text">{{'RENEWAL_INPROGRESS_STATIC_TEXT11' | globalTranslate }} {{caseDetails.lastAccessedOn | date:'MM/dd/yyyy'}}<span class="sr-only">.</span></li>
							</ul>
						</div>
					</div>
				</div>
				<div tabindex="0" class="card card-body shadow mb-2 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start"
					[ngClass]="{'applyColor': appType === 'new'}" (click)="select('new')" role="button">
			
					<div class="mb-3 mb-md-0 me-0  flex-shrink-0 d-flex justify-content-center">
						<img class="dot" aria-hidden="true" alt="" src="../../../assets/images/Icons/Start_new_app.svg">
					</div>
					<div class="flex-grow-1 min-w-0 w-100">
						<div class="section-column spl-padding"><strong *ngIf="!isPreterm"
								class="tile_header">{{'RENEWAL_INPROGRESS_STATIC_TEXT12' | globalTranslate }}</strong>
							<strong *ngIf="isPreterm" class="tile_header">{{'QFR_INPROGRESS_STATIC_TEXT12' | globalTranslate }}</strong>
							<ul *ngIf="caseDetails" class="list-unstyled">
								<li class="small tile-margin tile-text">{{'TABLE_DETAIL_NUMBER' | globalTranslate}}: {{caseDetails.caseNumber}}</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row mt-3 m-1">
		<button id="continue" class="col-md-2 btn btn-secondary" (click)="next()">
			{{'NEXT' | globalTranslate }}
		</button>
	</div>

</div>